export default __webpack_public_path__ + "static/media/s2_female.f6a2eac0.wav";